var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Switch, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Add01Icon, Edit02Icon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { AppConsts } from '../../../application/common/constants/app-consts';
import { RoleCategories } from '../../../application/common/constants/role-categories';
import { getFilteredStringOperators } from '../../../application/common/helpers/grid-filter-operators';
import { useGetPaginatedRolesQuery, useUpdateRoleStatusMutation } from '../../../application/features/roles/role-api';
import { useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
import ConfirmDialog from '../../components/ConfirmDialog';
import FilterButton from '../../components/FilterButton';
import PageHeaderButton from '../../components/PageHeaderButton';
import ProtectedElement from '../../components/ProtectedElement';
import { Permissions } from '../../permissions';
import CreateRole from './create-role';
import RolesCard from './roles-cards';
import RolesDatagrid from './roles-datagrid';
var Roles = function () {
    var _a;
    var theme = useTheme();
    var navigate = useNavigate();
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var isLg = useMediaQuery(theme.breakpoints.up('lg'));
    var _c = __read(useState(false), 2), openFilterDrawer = _c[0], setOpenFilterDrawer = _c[1];
    var handleFilterClick = function () {
        setOpenFilterDrawer(function (prev) { return !prev; });
    };
    var _d = __read(useState({
        hasUserCount: true,
        roleName: '',
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined
    }), 2), roleFilters = _d[0], setRoleFilters = _d[1];
    var _e = __read(useState({
        items: []
    }), 2), filterModel = _e[0], setFilterModel = _e[1];
    var _f = __read(useState(false), 2), newRole = _f[0], setNewRole = _f[1];
    var _g = __read(useState(false), 2), updateStatusConfirmOpen = _g[0], setUpdateStatusConfirmOpen = _g[1];
    var _h = __read(useState(false), 2), updateStatus = _h[0], setUpdateStatus = _h[1];
    var _j = __read(useState(''), 2), updateStatusId = _j[0], setUpdateStatusId = _j[1];
    var _k = __read(useState(''), 2), updateStatusTitle = _k[0], setUpdateStatusTitle = _k[1];
    var _l = __read(useState(''), 2), updateStatusContent = _l[0], setUpdateStatusContent = _l[1];
    var _m = useGetPaginatedRolesQuery(roleFilters, {
        refetchOnMountOrArgChange: true
    }), data = _m.data, isFetching = _m.isFetching;
    var _o = (data !== null && data !== void 0 ? data : {}).items, roles = _o === void 0 ? [] : _o;
    var _p = __read(useUpdateRoleStatusMutation(), 2), triggerUpdateStatus = _p[0], _q = _p[1], isUpdateStatusLoading = _q.isLoading, isUpdateStatusSuccess = _q.isSuccess;
    var _r = useForm({
        defaultValues: {
            hasUserCount: true,
            roleName: ''
        }
    }), control = _r.control, handleSubmit = _r.handleSubmit, getValues = _r.getValues, errors = _r.formState.errors, reset = _r.reset;
    useEffect(function () {
        if (isUpdateStatusSuccess) {
            if (updateStatus === true) {
                enqueueSnackbar(tWithField('toolTips.activateSuccess', 'common.role'), {
                    autoHideDuration: 3000,
                    variant: 'success',
                    anchorOrigin: { horizontal: 'right', vertical: 'top' }
                });
            }
            else {
                enqueueSnackbar(tWithField('toolTips.deactivateSuccess', 'common.role'), {
                    autoHideDuration: 3000,
                    variant: 'success',
                    anchorOrigin: { horizontal: 'right', vertical: 'top' }
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUpdateStatusSuccess]);
    var filterRoles = function () {
        setRoleFilters(function (prev) { return (__assign(__assign({}, prev), { roleName: getValues('roleName'), hasUserCount: true })); });
    };
    var rolesColumns = __spreadArray(__spreadArray([
        {
            field: 'name',
            headerName: translate('common.role'),
            type: 'string',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.5 : 0.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'category',
            headerName: translate('roles.category'),
            type: 'string',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.5 : 0.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators(),
            renderCell: function (params) {
                if (!params.value) {
                    return null;
                }
                var translatedLabel = params.value;
                switch (params.value) {
                    case 'Others':
                        translatedLabel = translate('roles.others');
                        break;
                    case 'Technician':
                        translatedLabel = translate('common.technician');
                        break;
                    default:
                        break;
                }
                return translatedLabel;
            }
        }
    ], __read(((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin
        ? [
            {
                field: 'companyName',
                headerName: translate('common.company'),
                flex: isXs
                    ? undefined
                    : isMd
                        ? undefined
                        : isscreen600900
                            ? undefined
                            : isSm
                                ? 0.5
                                : 0.5,
                minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
                width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
                filterOperators: getFilteredStringOperators()
            }
        ]
        : [])), false), [
        {
            field: 'usersInRole',
            filterable: false,
            headerName: translate('common.users'),
            type: 'string',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.5 : 0.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined
        },
        {
            field: 'isActive',
            headerName: translate('common.active'),
            filterable: false,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 0.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 150 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            renderCell: function (params) { return (_jsx(ProtectedElement, { permissions: [Permissions.Roles.Update], children: _jsx(Switch, { checked: params.row.isActive, disabled: isUpdateStatusLoading ||
                        params.row.category === RoleCategories.SuperAdmin ||
                        params.row.isSystem, onClick: function () {
                        return onUpdateStatus(params.row.id, !params.row.isActive, params.row.usersInRole);
                    } }) })); }
        },
        {
            field: 'edit',
            headerName: translate('roles.editPermissions'),
            headerAlign: 'center',
            align: 'center',
            disableColumnMenu: true,
            sortable: false,
            filterable: false,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.5 : 0.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            renderCell: function (params) { return (_jsx(ProtectedElement, { permissions: [Permissions.Roles.Update], children: _jsx(IconButton, { disabled: params.row.category === RoleCategories.SuperAdmin, size: 'medium', onClick: function () { return onEditRole(params.row.id); }, children: _jsx(Edit02Icon, {}) }) })); }
        }
    ], false);
    var handlePaginationModelChange = function (model) {
        setRoleFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var handleSortModelChange = function (model) {
        setRoleFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setRoleFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setRoleFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setRoleFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var rowCountRef = useRef((_a = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _a !== void 0 ? _a : 0);
    var rowCount = useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data === null || data === void 0 ? void 0 : data.totalCount]);
    var onEditRole = function (roleId) {
        navigate("/roles-permissions/".concat(roleId));
    };
    var onUpdateStatus = function (id, status, userCount) {
        setUpdateStatusId(id);
        setUpdateStatus(status);
        if (status === false) {
            setUpdateStatusTitle(tWithFunction('actions.deactivateFunction', 'common.role'));
            var userOrUsers = translate(userCount === 1 ? 'common.user' : 'common.users');
            var message = userCount === 0
                ? ''
                : translate('roles.deactivateWarning1', { count: userCount, field: userOrUsers });
            var statusContent = "".concat(translate('roles.deactivateWarning2'), " ").concat(userCount === 0 ? '' : message);
            setUpdateStatusContent(statusContent);
        }
        else {
            setUpdateStatusTitle(tWithFunction('actions.activateFunction', 'common.role'));
            setUpdateStatusContent(translate('roles.activateWarning'));
        }
        setUpdateStatusConfirmOpen(true);
    };
    var onConfirmUpdateStatus = function () {
        triggerUpdateStatus({ id: updateStatusId, isActive: updateStatus });
        setUpdateStatusConfirmOpen(false);
    };
    return (_jsxs(Box, { sx: {
            width: '100%',
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [_jsxs(Box, { mb: { xs: 0, md: 0, lg: 2 }, display: 'flex', flexDirection: 'row', justifyContent: isXs || isscreen600900 || iscreen9001200 || isscreen600900Landscape ? 'space-between' : '', alignItems: 'center', gap: 1, children: [_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Typography, { variant: isXs ? 'h4' : 'h3', color: '#009983', children: translate('common.rolesPermissions') }), _jsx(ProtectedElement, { permissions: [Permissions.Roles.Create], children: _jsx(PageHeaderButton, { text: translate('actions.add'), icon: _jsx(Add01Icon, { size: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', onClick: function () { return setNewRole(true); }, variant: 'contained', color: 'primary', title: tWithFunction('actions.addFunction', 'common.role') }) })] }), !isXs && !isIpadMini && !isIpadMiniLandscape && !isLg && (_jsx(FilterButton, { variant: 'soft', onClick: handleFilterClick }))] }), isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(RolesCard, { reset: reset, control: control, errors: errors, filterRoles: filterRoles, handleSubmit: handleSubmit, isFetching: isFetching, isUpdateStatusLoading: isUpdateStatusLoading, onEditRole: onEditRole, onUpdateStatus: onUpdateStatus, openFilterDrawer: openFilterDrawer, roles: roles, setOpenFilterDrawer: setOpenFilterDrawer, roleFilters: roleFilters, setRoleFilters: setRoleFilters, isscreen600900Landscape: isscreen600900Landscape, isIpadMini: isIpadMini })) : (_jsx(RolesDatagrid, { control: control, errors: errors, filterRoles: filterRoles, handlePaginationModelChange: handlePaginationModelChange, handleSubmit: handleSubmit, isFetching: isFetching, iscreen9001200: iscreen9001200, isscreen600900: isscreen600900, isscreen9001200Landscape: isscreen9001200Landscape, openFilterDrawer: openFilterDrawer, paginationModel: {
                    page: roleFilters.page - 1,
                    pageSize: roleFilters.pageSize
                }, filterModel: filterModel, handleFilterModelChange: handleFilterModelChange, handleSortModelChange: handleSortModelChange, reset: reset, roleFilters: roleFilters, rowCount: rowCount, roles: roles, rolesColumns: rolesColumns, setOpenFilterDrawer: setOpenFilterDrawer })), _jsx(CreateRole, { onClose: function () { return setNewRole(false); }, open: newRole }), _jsx(ConfirmDialog, { open: updateStatusConfirmOpen, onClose: function () { return setUpdateStatusConfirmOpen(false); }, onConfirm: onConfirmUpdateStatus, title: updateStatusTitle, content: updateStatusContent, confirmButtonText: translate('actions.confirm'), closeButtonText: translate('actions.cancel'), mode: 'warning' })] }));
};
export default Roles;
